import script from "./cplb.vue?vue&type=script&setup=true&lang=js"
export * from "./cplb.vue?vue&type=script&setup=true&lang=js"

import "./cplb.vue?vue&type=style&index=0&id=70030c0c&scoped=true&lang=scss"

import exportComponent from "D:\\liu\\jmzc\\jimuERPVUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70030c0c"]])

export default __exports__